import React, { useEffect } from "react";
import { Link } from "react-scroll";
import '../css/redes.css';
import 'animate.css';
import { FaDiscord, FaDollarSign, FaTiktok, FaTwitter } from 'react-icons/fa';
import { BiWorld } from 'react-icons/bi';
import ico from '../assets/favicon512.png';

export default function Principal() {

    const corPrincipal = '#dc494c';


    useEffect(() => {
        setTimeout(() => {
            document.querySelectorAll('.single-rede')[0].style.opacity = 1;
            document.querySelectorAll('.single-rede')[0].classList.add('animate__flipInX');
        }, 500)

        setTimeout(() => {
            document.querySelectorAll('.single-rede')[1].style.opacity = 1;
            document.querySelectorAll('.single-rede')[1].classList.add('animate__flipInX');
        }, 1500)

        setTimeout(() => {
            document.querySelectorAll('.single-rede')[2].style.opacity = 1;
            document.querySelectorAll('.single-rede')[2].classList.add('animate__flipInX');
        }, 2500)

        setTimeout(() => {
            document.querySelectorAll('.single-rede')[3].style.opacity = 1;
            document.querySelectorAll('.single-rede')[3].classList.add('animate__flipInX');
        }, 3500)

        setTimeout(() => {
            document.querySelectorAll('.single-rede')[4].style.opacity = 1;
            document.querySelectorAll('.single-rede')[4].classList.add('animate__flipInX');
        }, 4500)
    }, [])


    return (
        <div className="container flex-center container-redes-father">
            <div className="container-redes animate__animated animate__zoomInUp">
                <div style={{ marginTop: 20, flexDirection: 'column', color: '#111a21' }} className="flex-center">
                    <div style={{ backgroundImage: `url(${ico})`, borderRadius: 50, border: '1px solid ' + corPrincipal }} className='icon-header' ></div>
                    <h2>Taldo's Bar</h2>
                    <p>O RPG do seu Jeito !</p>
                </div>

                <div className="container-single-rede">
                    <a target="_blank" href="https://discord.gg/acMgWMDeBC">
                        <div style={{ backgroundColor: '#7289da', color: 'white' }} className="single-rede animate__animated">
                            <FaDiscord size={30} />
                            <p className="text-single-rede">Discord</p>
                        </div>
                    </a>

                    <a target="_blank" href="https://www.tiktok.com/@taldosbars_official">
                        <div style={{ backgroundColor: 'black', color: 'white' }} className="single-rede animate__animated">
                            <FaTiktok size={25} />
                            <p className="text-single-rede">TikTok</p>
                        </div>
                    </a>

                    <a target="_blank" href="https://twitter.com/taldosbars_ofc">
                        <div style={{ backgroundColor: '#1D9BF0', color: 'white' }} className="single-rede animate__animated">
                            <FaTwitter size={30} />
                            <p className="text-single-rede">Twitter</p>
                        </div>
                    </a>

                    <a target="_blank" href="https://apoia.se/taldobars">
                        <div style={{ backgroundColor: '#ed5544', color: 'white' }} className="single-rede animate__animated">
                            <FaDollarSign size={30} />
                            <p className="text-single-rede">Apoia-se</p>
                        </div>
                    </a>

                    <a target="_blank" href={window.location.origin + '/site'}>
                        <div style={{ backgroundColor: '#111a21', color: 'white' }} className="single-rede animate__animated">
                            <BiWorld size={30} />
                            <p className="text-single-rede">Taldo's Bar</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    )

}